<!-- ###################  LOAD COACHING COMPONENTS ROW BELOW RADICALS WIDGETS WITH TM'S COACHING INSIGHT DETAILS ################### -->
<div
    *ngIf="
        (people | async) &&
        ((forceOpenTeamOA | async) == true ||
            (coachingViewShortName | async) == CoachingComponentName.OA)
    "
>
    <ng-container *ngTemplateOutlet="coachingInsightComponentOa"></ng-container>
</div>
<div
    *ngIf="
        (forceOpenTeamOA | async) == true ||
        (coachingViewShortName | async) == CoachingComponentName.FLOA
    "
>
    <ng-container
        *ngTemplateOutlet="coachingInsightComponentFloa"
    ></ng-container>
</div>

<div
    class="shadow-sm smallwidth cmps-widget-coaching-insight cmps-widget-coaching-insight--border cmps-widget-coaching-insight--first-load"
    [ngClass]="{ 'filter-window-opened': filterOpen === true }"
>
    <div
        class="card"
        role="complementary"
        [attr.aria-labelledby]="compConfig?.id"
    >
        <div class="card-body">
            <div class="container-fluid">
                <div
                    *ngIf="dataFailed == true"
                    class="p-3 text-center"
                >
                    {{ i18n._711_NO_DATA_AVAILABLE | translate }}.
                </div>

                <!-- ###################  ADD COACHING COMPONENTS AS VIEWS HERE  ################### -->
                <div
                    class="row oapopulation"
                    *ngIf="
                        (people | async) &&
                        ((forceOpenTeamOA | async) == true ||
                            (coachingViewShortName | async) ==
                                CoachingComponentName.OA)
                    "
                >
                    <div class="col-12">
                        <button
                            *ngIf="cameFromFloa == true"
                            (click)="goBackToStoredFavourite()"
                            class="btn legend-button back"
                        >
                            <cmps-icon svgIcon="reply"></cmps-icon>
                            <span>{{
                                i18n._7495_BACK_TO_PREVIOUS_VIEW | translate
                            }}</span>
                        </button>

                        <cmps-team-oa-metrics
                            [selectedUser]="favouriteView | async"
                            [coachingInsightUserId]="coachingInsightUserId"
                            [oaPeople]="oaPeople"
                            (metricsRendered)="onMetricsRendered($event)"
                            (reorderedPeople)="setOaPeopleUsingService()"
                            (toggledDisplay)="setOaPeopleUsingService()"
                            (filterToggled)="filterOpen = $event"
                        >
                        </cmps-team-oa-metrics>
                    </div>
                </div>

                <div
                    class="row"
                    *ngIf="
                        (forceOpenTeamOA | async) == true ||
                        (coachingViewShortName | async) ==
                            CoachingComponentName.FLOA
                    "
                >
                    <div class="col-12">
                        <cmps-frontline-oa
                            [periodTypeId]="periodTypeId"
                            [periodTypeDate]="periodTypeDate"
                            [selectedUser]="favouriteView | async"
                            [floaData]="floa | async"
                            (selectedUserChange)="
                                handleCurrentViewChange(
                                    $event,
                                    true,
                                    CoachingComponentType.OA
                                )
                            "
                        >
                        </cmps-frontline-oa>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- TM DETAILS template//coachingInsightComponents -->
<ng-template #coachingInsightComponentOa>
    <div
        class="kpi-context-container cmps-widget-coaching-insight--kpi--ctx--container"
    >
        <div class="kpi-stat kpi-stat-noborder"></div>
        <div
            class="kpi-context-data kpi-context-data-padding"
            *ngIf="_componentOa"
        >
            <div class="d-flex align-items-center mr-4">
                <span>{{ i18n._7372_TOTAL_OPPORTUNITIES | translate }}</span>
                <span class="mx-3">{{
                    _componentOa.componentAttributes.totalOpportunities
                        | number: '1.0-0'
                }}</span>
            </div>
            <div class="d-flex align-items-center mx-4">
                <span>{{ i18n._7427_EXPECTED_OPPORTUNITIES | translate }}</span>
                <span class="mx-3">
                    {{
                        _componentOa.componentAttributes.expectedOpportunities
                            | number: '1.0-0'
                    }}</span
                >
            </div>
            <div class="d-flex align-items-center mx-4">
                <span>{{ i18n._7371_COACHED_OPPORTUNITIES | translate }}</span>
                <span class="mx-3">{{
                    _componentOa.componentAttributes.coachedOpportunities
                        | number: '1.0-0'
                }}</span>
            </div>
            <div class="d-flex align-items-center mx-4">
                <span>{{ i18n._7313_LAST_UPDATE | translate }}</span>
                <span class="mx-3">{{
                    _componentOa.componentAttributes.lastUpdated
                        | cmpsDate: 'MMM d, y, h:mm a'
                }}</span>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #coachingInsightComponentFloa>
    <div
        class="kpi-context-container cmps-widget-coaching-insight--kpi--ctx--container"
    >
        <div class="kpi-stat kpi-stat-noborder"></div>
        <div
            class="kpi-context-data kpi-context-data-padding"
            *ngIf="_componentFloa"
        >
            <div class="d-flex align-items-center mr-4">
                <span>{{ i18n._7372_TOTAL_OPPORTUNITIES | translate }}</span>
                <span class="mx-3">{{
                    _componentFloa.componentAttributes.totalOpportunities
                        | number: '1.0-0'
                }}</span>
            </div>
            <div class="d-flex align-items-center mx-4">
                <span>{{ i18n._7427_EXPECTED_OPPORTUNITIES | translate }}</span>
                <span class="mx-3">{{
                    _componentFloa.componentAttributes.expectedOpportunities
                        | number: '1.0-0'
                }}</span>
            </div>
            <div class="d-flex align-items-center mx-4">
                <span>{{
                    i18n._7481_FUNDED_COACHED_OPPORTUNITIES | translate
                }}</span>
                <span class="mx-3">{{
                    _componentFloa.componentAttributes.fundedCoachedOpps
                        | number: '1.0-0'
                }}</span>
            </div>
            <div class="d-flex align-items-center mx-4">
                <span>{{ i18n._7493_TOTAL_AGENTS | translate }}</span>
                <span class="mx-3">{{
                    _componentFloa.componentAttributes.totalAgents
                        | number: '1.0-0'
                }}</span>
            </div>
            <div class="d-flex align-items-center mx-4">
                <span>{{
                    i18n._7494___OF_AGENTS_WITH_OPPORTUNITIES | translate
                }}</span>
                <span class="mx-3">{{
                    _componentFloa.componentAttributes.pctAgentsWithOpps
                        | percent
                }}</span>
            </div>
        </div>
    </div>
</ng-template>
